angular.module('app').factory('casinoCategoryService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/CasinoCategory/");

        return {
            create: function (requestData) {
                return restAngular.
                    one("create").
                    post("", requestData)
            },
            get: function (requestData) {
                return restAngular.
                    one("getList").
                    customGET(param(requestData))
            },
            getCategories: function (requestData) {
                return restAngular.
                one("get").
                customGET(param(requestData))
            },
            edit: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            },
            changeStatusCategoryById: function (request) {
                var requestObject = {
                    id: request.id,
                    status: request.status === 'archive' ? 'published' : 'archive'
                };
                return restAngular.
                one("changeitem").
                customGET(param(requestObject))
            },
            toggleItemInactive: function (pageId, title) {
                var requestObject = {
                    id: pageId,
                    status: title !== 'Publish' ? "inactive" : "published"
                };
                return restAngular.
                one("changeitem").
                customGET(param(requestObject))
            },
            setIcon: function (requestData) {
                return restAngular.
                one("seticon").
                post("", requestData)
            }
        }
    }
]);